const { algoliasearch, instantsearch } = window;
const searchClient = algoliasearch('DZZJIJO3KR', '4d03fef5a1f4656153692653925166f4');
const search = instantsearch({
    indexName: 'stylebook',
    searchClient,
    future: {
        preserveSharedStateOnUnmount: true
    }
});
search.addWidgets([
    instantsearch.widgets.searchBox({
        container: '#searchbox'
    }),
    instantsearch.widgets.hits({
        container: '#hits',
        templates: {
            item: (hit, { html, components })=>html`
        <article>
          <div>
            <h1>${components.Highlight({
                    hit,
                    attribute: 'title'
                })}</h1>
            <p>${components.Highlight({
                    hit,
                    attribute: 'description'
                })}</p>
          </div>
        </article>
      `
        }
    }),
    instantsearch.widgets.configure({
        hitsPerPage: 8
    }),
    instantsearch.widgets.pagination({
        container: '#pagination'
    })
]);
search.start();

//# sourceMappingURL=index.6825f15e.js.map
